// src/components/requests/OfferCard.jsx
import React, { useState } from 'react';

const OfferCard = ({ offer, index, onAccept, onContact }) => {
  const [contactOpen, setContactOpen] = useState(false);
  const [message, setMessage] = useState("");
  const [sending, setSending] = useState(false);

  const handleSend = async (e) => {
    e.preventDefault();
    if (!message.trim()) return;
    setSending(true);

    await new Promise(r => setTimeout(r, 1000)); // simulate

    if (onContact) onContact(offer, message);

    setSending(false);
    setContactOpen(false);
    setMessage("");
  };

  return (
    <>
      <div
        className="bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-xl p-6 shadow-sm flex flex-col animate-fade-in"
        style={{ animationDelay: `${index * 80}ms` }}
      >
        {/* Provider Header */}
        <div className="flex justify-between items-start mb-4">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-full bg-indigo-600 text-white flex items-center justify-center font-bold">
              {offer.providerName?.charAt(0)}
            </div>
            <div>
              <h3 className="font-semibold text-slate-900 dark:text-white">{offer.providerName}</h3>
              <p className="text-xs text-slate-500">{offer.providerType}</p>
            </div>
          </div>

          <div className="flex items-center text-yellow-600">
            ⭐ <span className="ml-1 text-sm">{offer.rating}</span>
          </div>
        </div>

        {/* Offer Description */}
        <h4 className="font-bold text-lg text-slate-800 dark:text-slate-200 mb-2">
          {offer.offerTitle}
        </h4>
        <p className="text-sm text-slate-600 dark:text-slate-300 mb-4 line-clamp-3">
          {offer.description}
        </p>

        {/* Price + Availability */}
        <div className="border-t border-slate-200 dark:border-slate-700 pt-4 mt-auto">
          <div className="flex justify-between mb-4">
            <div>
              <p className="text-xs text-slate-400 uppercase">Estimate</p>
              <p className="text-xl font-semibold text-indigo-600">{offer.priceEstimate}</p>
            </div>
            <div className="text-right">
              <p className="text-xs text-slate-400 uppercase">Availability</p>
              <p className="text-sm font-medium">{offer.availability}</p>
            </div>
          </div>

          {/* Actions */}
          <div className="flex gap-3">
            <button
              className="flex-1 py-2 border border-slate-300 dark:border-slate-600 rounded-lg bg-white dark:bg-slate-700 text-sm"
              onClick={() => setContactOpen(true)}
            >
              Contact
            </button>

            <button
              className="flex-1 py-2 bg-indigo-600 text-white rounded-lg text-sm hover:bg-indigo-700"
              onClick={() => onAccept && onAccept(offer)}
            >
              Accept
            </button>
          </div>
        </div>
      </div>

      {/* Contact Modal */}
      {contactOpen && (
        <div className="fixed inset-0 bg-black/40 backdrop-blur-sm flex items-center justify-center p-4 z-50">
          <div className="bg-white dark:bg-slate-800 rounded-xl w-full max-w-md p-6 border border-slate-200 dark:border-slate-700">
            <h3 className="font-bold text-lg mb-4">
              Contact {offer.providerName}
            </h3>

            <form onSubmit={handleSend}>
              <textarea
                rows={5}
                className="w-full p-3 rounded-lg border border-slate-300 dark:border-slate-600 bg-slate-50 dark:bg-slate-900 mb-4"
                value={message}
                onChange={(e) => setMessage(e.target.value)}
              />

              <div className="flex justify-end gap-2">
                <button
                  type="button"
                  onClick={() => setContactOpen(false)}
                  className="px-4 py-2 text-sm bg-slate-200 rounded-lg"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  disabled={sending}
                  className="px-4 py-2 text-sm bg-indigo-600 text-white rounded-lg"
                >
                  {sending ? "Sending…" : "Send"}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </>
  );
};

export default OfferCard;
